import { render, staticRenderFns } from "./FileIcon.vue?vue&type=template&id=40cab5c5&scoped=true&"
import script from "./FileIcon.vue?vue&type=script&lang=js&"
export * from "./FileIcon.vue?vue&type=script&lang=js&"
import style0 from "./FileIcon.vue?vue&type=style&index=0&id=40cab5c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cab5c5",
  null
  
)

export default component.exports